import React from 'react'
import DatePicker from "react-datepicker"

import "react-datepicker/dist/react-datepicker.css";

const DateRangeSelector = ({beginDate, endDate, onSelectBeginDate, onSelectEndDate}) => {
    return (
        <div>
            Begin Date: <DatePicker selected={beginDate} onSelect={date => {
                onSelectBeginDate(date)
            }}/>
            End Date: <DatePicker selected={endDate} onSelect={date => {
                onSelectEndDate(date)
            }}/>
        </div>
    )
}

export default DateRangeSelector